import styled from 'styled-components';

import { SelectTheme } from './index';
import { StyleColor, NewStyleColor } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

interface SelectProps {
	theme: {
		theme: SelectTheme;
	};
}

interface SelectValueProps {
	isOpen: boolean;
}

interface SelectOptionButtonProps extends SelectProps {
	isActive: boolean;
}

const Wrapper = styled('div')`
	position: relative;
`;

const SelectValue = styled('div')`
	position: relative;
	padding: 15px 60px 15px 30px;
	border: 1px solid ${StyleColor.Grey100};
	border-radius: 10px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 20px;
	color: ${StyleColor.Black};

	${({ theme: { theme } }: SelectProps) => theme === SelectTheme.DARK && `
		color: ${hexToRgba(StyleColor.White, 75)};
		border-color: currentColor;
	`}

	&:hover {
		border-color: ${StyleColor.Blue600};
	}

	svg {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		right: 30px;
		width: 18px;
		height: 18px;
		fill: ${StyleColor.Blue600};
	}

	${({ isOpen }: SelectValueProps) => isOpen && `
		border-color: ${StyleColor.Blue600};

		svg {
			transform: rotate(180deg) translateY(-50%);
			transform-origin: 50% 0;
		}
	`};
`;

const SelectDropdown = styled('div')`
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	padding: 5px 0;
	border: 1px solid ${StyleColor.Grey100};
	border-radius: 10px;
	background-color: ${StyleColor.White};

	${({ theme: { theme } }: SelectProps) => theme === SelectTheme.DARK && `
		background-color: ${NewStyleColor.Grey900};
		border-color: ${hexToRgba(StyleColor.White, 75)};
	`}
`;

const SelectOptions = styled('ul')`
	margin: 0;
	padding: 0;
	list-style-type: none;
	max-height: 200px;
	overflow-y: auto;

	li + li {
		border-top: 1px solid ${StyleColor.Grey100};
	}

	${({ theme: { theme } }: SelectProps) => theme === SelectTheme.DARK && `
		li + li {
			border-color: ${hexToRgba(StyleColor.White, 75)};
		}
	`}
`;

const SelectOptionButton = styled('button')`
	width: 100%;
	margin: 0;
	padding: 15px 30px;
	border: 0;
	outline: 0;
	background-color: ${StyleColor.White};
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 20px;
	color: ${StyleColor.Black};
	text-align: left;
	cursor: pointer;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	&:hover {
		background-color: ${NewStyleColor.Blue50};
		color: ${StyleColor.Blue600};
	}

	${({ isActive }: SelectOptionButtonProps) => isActive && `
		background-color: ${NewStyleColor.Blue50};
		color: ${StyleColor.Blue600};
	`};

	${({ theme: { theme }, isActive }: SelectOptionButtonProps) => theme === SelectTheme.DARK && `
		background-color: ${NewStyleColor.Grey900};
		color: ${hexToRgba(StyleColor.White, 75)};

		&:hover {
			background-color: ${hexToRgba(StyleColor.White, 25)};
			color: ${StyleColor.White};
		}

		${isActive && `
			background-color: ${hexToRgba(StyleColor.White, 25)};
			color: ${StyleColor.White};
		`};
	`}
`;

export {
	Wrapper,
	SelectValue,
	SelectDropdown,
	SelectOptions,
	SelectOptionButton,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Form/Select/styles.ts